import React, { useState } from 'react'

export const ProdottoContext = React.createContext()

const ProdottoContextProvider = (props) => {
  const [showDuplicaPersonalizzazione, setShowDuplicaPersonalizzazione] = useState(false)
  const [showQuantitaInsufficiente, setShowQuantitaInsufficiente] = useState(false)
  const [showQuantitaEccessiva, setShowQuantitaEccessiva] = useState(false)
  const [quantitaMassimaPersonalizzabile, setQuantitaMassimaPersonalizzabile] = useState(null)

  return (
    <ProdottoContext.Provider
      value={{
        showDuplicaPersonalizzazione,
        setShowDuplicaPersonalizzazione,
        showQuantitaInsufficiente,
        setShowQuantitaInsufficiente,
        showQuantitaEccessiva,
        setShowQuantitaEccessiva,
        quantitaMassimaPersonalizzabile,
        setQuantitaMassimaPersonalizzabile,
      }}
    >
      {props.children}
    </ProdottoContext.Provider>
  )
}

export default ProdottoContextProvider
